$(document).ready(function () {
  if ($("#offer-message").length === 0) {
    $(".offers-all-wrap").append('<div id="offer-message" style="display:none; margin-top:10px; padding:5px; background:#f8f8f8; border-radius:4px;"></div>');
  }
  
  // Function to refresh mini cart content
  function refreshMiniCart() {
    console.log("Refreshing mini cart");
    
    // First get the cart data to ensure we have the latest
    $.ajax({
      url: '/cart.js',
      type: 'GET',
      dataType: 'json',
      success: function(cart) {
        console.log("Cart data fetched:", cart);
        
        // Then force a refresh of the t4s drawer
        if (typeof t4s !== 'undefined' && t4s.Cart) {
          // If t4s object exists, try to use its native refresh method
          if (typeof t4s.Cart.getCart === 'function') {
            console.log("Using t4s native getCart method");
            t4s.Cart.getCart();
            return;
          }
        }
        
        // If no t4s native method, fetch the drawer content
        $.ajax({
          url: '/cart?view=drawer',
          type: 'GET',
          success: function(response) {
            console.log("Drawer content fetched");
            
            // Find and extract the cart items
            var cartItemsMatch = response.match(/<div\s+data-cart-items[^>]*>([\s\S]*?)<\/div><div\s+data-cart-tools/i);
            if (cartItemsMatch && cartItemsMatch[1]) {
              console.log("Cart items content found");
              
              // Update cart items
              var cartItems = cartItemsMatch[1];
              $('[data-cart-items]').html(cartItems);
              
              // Update cart count
              $('#t4s-mini_cart').attr('data-ccount', cart.item_count);
              
              // Update total price
              var totalPrice = '₹ ' + (cart.total_price/100).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
              $('.t4s-cart__totalPrice').html(totalPrice);
              
              console.log("Mini cart updated successfully");
            } else {
              console.log("Could not find cart items in response, using fallback");
              manuallyUpdateCart(cart);
            }
          },
          error: function() {
            console.log("Error fetching drawer content, using fallback");
            manuallyUpdateCart(cart);
          }
        });
      },
      error: function(xhr, status, error) {
        console.error("Error fetching cart data:", error);
      }
    });
  }
  
  // Updated function to manually update the cart
  function manuallyUpdateCart(cart) {
    // Update cart count
    $('#t4s-mini_cart').attr('data-ccount', cart.item_count);
    
    // Update total price
    var totalPrice = '₹ ' + (cart.total_price/100).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    $('.t4s-cart__totalPrice').html(totalPrice);
    
    // Clear and recreate cart items
    var $cartItems = $('[data-cart-items]');
    $cartItems.empty();
    
    // If cart is empty
    if (cart.items.length === 0) {
      $cartItems.html('<div class="t4s-mini_cart__empty">Your cart is empty</div>');
      return;
    }
    
    // Build cart items HTML
    cart.items.forEach(function(item) {
      // Get image URL and format it for different sizes
      var imgUrl = item.image || '';
      
      // Handle image URL
      if (imgUrl && !imgUrl.includes('http')) {
        imgUrl = 'https:' + imgUrl;
      }
      
      // Create image URLs for different sizes
      var imgUrl120 = imgUrl.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_120x.$1').replace(/\?v=/, '&width=120&v=');
      var imgUrl240 = imgUrl.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_240x.$1').replace(/\?v=/, '&width=240&v=');
      
      // Format price
      var price = '₹ ' + (item.final_price/100).toFixed(0);
      var compareAtPrice = item.original_price > item.final_price ? 
        '₹ ' + (item.original_price/100).toFixed(0) : '';
      
      var priceHtml = compareAtPrice ? 
        '<del>' + compareAtPrice + '</del><ins>' + price + '</ins>' : 
        price;
      
      // Generate HTML for cart item
      var itemHtml = `
        <div data-cart-item="" data-pid="${item.product_id}" class="t4s-mini_cart__item cart_item_${item.variant_id} t4s-d-flex t4s-align-items-center t4s-pr t4s-oh">
          <a href="${item.url}" class="t4s-mini_cart__img t4s-pr t4s-oh t4s_ratio t4s-bg-11 t4s-child-lazyloaded" style="background: url(${imgUrl}?width=1);--aspect-ratioapt:1.0">
            <img class="lazyautosizes lazyloadt4sed" width="120" height="120" 
                 src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" 
                 data-widths="[120, 240]" 
                 data-sizes="auto" 
                 alt="${item.product_title}" 
                 data-srcset="${imgUrl}?width=120 120w, ${imgUrl}?width=240 240w" 
                 sizes="120px" 
                 srcset="${imgUrl}?width=120 120w, ${imgUrl}?width=240 240w">
            <div class="t4s-cart-ld__bar t4s-pe-none t4s-dn" hidden="">
              <span>
                <svg width="16" height="16" hidden="" class="t4s-cart-spinner" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="t4s-path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
                <svg class="t4s-cart-check" viewBox="0 0 448 512" width="16" height="16" hidden=""><use href="#icon-cart-check"></use></svg>
              </span>
            </div>
          </a>
          <div class="t4s-mini_cart__info">
            <a href="${item.url}" class="t4s-mini_cart__title t4s-truncate">${item.product_title}</a>
            <div class="t4s-mini_cart__meta">
              <div class="t4s-cart_meta_price">
                <div class="t4s-cart_price">${priceHtml}</div>
              </div>
            </div>
            <div class="t4s-mini_cart__actions">
              <div data-quantity-wrapper="" class="t4s-quantity-wrapper t4s-quantity-cart-item"> 
                <button data-quantity-selector="" data-decrease-qty="" type="button" class="t4s-quantity-selector is--minus">
                  <svg viewBox="0 0 24 24" width="17"><use href="#icon-cart-remove"></use></svg>
                </button>
                <input data-action-change="" data-quantity-value="" type="number" 
                       id="miniupdates_${item.key}" 
                       data-id="${item.key}" 
                       class="t4s-quantity-input" 
                       step="1" 
                       min="0" 
                       max="21" 
                       name="updates[]" 
                       data-current-qty="${item.quantity}" 
                       value="${item.quantity}" 
                       size="4" 
                       pattern="[0-9]*" 
                       inputmode="numeric">
                <button data-quantity-selector="" data-increase-qty="" type="button" class="t4s-quantity-selector is--plus">
                  <svg focusable="false" class="icon icon--plus" viewBox="0 0 10 10" role="presentation">
                    <path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fill-rule="evenodd"></path>
                  </svg>
                </button>
              </div>
              <a href="/cart/change?quantity=0&amp;id=${item.key}" rel="nofollow" 
                 class="t4s-mini_cart__remove t4s-tooltip-actived" 
                 data-no-instant="" 
                 data-cart-remove="" 
                 data-id="${item.key}" 
                 data-tooltip="top-start" 
                 data-t4s-tooltip="Remove this item">
                <svg viewBox="0 0 24 24" width="17"><use href="#icon-cart-remove"></use></svg>
              </a>
            </div>
          </div>
        </div>
      `;
      
      $cartItems.append(itemHtml);
    });
    
    // Ensure images are loaded correctly
    fixCartImages();
    
    // Re-attach event handlers
    attachCartEvents();
  }

  // Function to fix cart images
  function fixCartImages() {
    $('.t4s-mini_cart__img').each(function() {
      var $this = $(this);
      var $img = $this.find('img');
      
      // If the image doesn't have a valid src but has a background style
      if ((!$img.attr('srcset') || $img.attr('srcset').includes('data:image')) && $this.attr('style') && $this.attr('style').includes('url(')) {
        // Extract the URL from the background style
        var bgUrlMatch = $this.attr('style').match(/url\(['"]?(.*?)['"]?\)/);
        if (bgUrlMatch && bgUrlMatch[1]) {
          var imgUrl = bgUrlMatch[1];
          
          // Make it absolute if needed
          if (imgUrl.startsWith('//')) {
            imgUrl = 'https:' + imgUrl;
          }
          
          // Set the image src and srcset
          $img.attr('src', imgUrl);
          var srcset = imgUrl.replace(/width=\d+/, 'width=120') + ' 120w, ' + 
                      imgUrl.replace(/width=\d+/, 'width=240') + ' 240w';
          $img.attr('srcset', srcset);
          $img.removeClass('lazyload');
        }
      }
      
      // Apply the lazy load classes and force loading
      $img.addClass('t4s-cart-img-loaded');
      
      // If there's a data-srcset but no srcset, copy it over
      if ($img.attr('data-srcset') && !$img.attr('srcset')) {
        $img.attr('srcset', $img.attr('data-srcset'));
      }
    });
  }
  
  // Function to attach event handlers to cart elements
  function attachCartEvents() {
    // Handle quantity changes
    $('[data-quantity-selector]').off('click').on('click', function() {
      var isPlus = $(this).hasClass('is--plus');
      var $input = $(this).siblings('[data-quantity-value]');
      var currentValue = parseInt($input.val()) || 0;
      var newValue = isPlus ? currentValue + 1 : Math.max(0, currentValue - 1);
      
      $input.val(newValue).trigger('change');
      
      // If using native theme functions, let them handle the update
      if (typeof t4s !== 'undefined' && t4s.Cart && typeof t4s.Cart.updateItemQuantity === 'function') {
        t4s.Cart.updateItemQuantity($(this).closest('[data-quantity-wrapper]').find('[data-quantity-value]')[0]);
      }
    });
    
    // Handle quantity input changes
    $('[data-quantity-value]').off('change').on('change', function() {
      var $this = $(this);
      var quantity = parseInt($this.val());
      var itemId = $this.data('id');
      
      if (isNaN(quantity)) return;
      
      // Update cart item quantity
      $.ajax({
        url: '/cart/change.js',
        type: 'POST',
        dataType: 'json',
        data: {
          id: itemId,
          quantity: quantity
        },
        success: function(cart) {
          console.log("Item quantity updated");
          // Validate cart after quantity change
          setTimeout(validateCart, 200);
        },
        error: function(xhr, status, error) {
          console.error("Error updating quantity:", error);
        }
      });
    });
    
    // Handle remove buttons
    $('[data-cart-remove]').off('click').on('click', function(e) {
      e.preventDefault();
      
      var itemId = $(this).data('id');
      
      // Remove item from cart
      $.ajax({
        url: '/cart/change.js',
        type: 'POST',
        dataType: 'json',
        data: {
          id: itemId,
          quantity: 0
        },
        success: function(cart) {
          console.log("Item removed");
          // Validate cart after removal
          setTimeout(validateCart, 200);
        },
        error: function(xhr, status, error) {
          console.error("Error removing item:", error);
        }
      });
    });
  }
  
  // Function to check cart and update checkboxes
  function checkCartAndUpdateCheckboxes() {
    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      success: function(cart) {
        console.log('Cart contents:', cart);
        var mainProductInCart = false;
        var mainProductId = parseInt($("#main-product-id").attr("data-product-id"));
        console.log('Current product ID:', mainProductId);
        
        // Check if main product is in cart
        for (var i = 0; i < cart.items.length; i++) {
          if (parseInt(cart.items[i].product_id) === mainProductId) {
            mainProductInCart = true;
            console.log('Found main product in cart');
            break;
          }
        }
        
        // Check each offer checkbox against cart contents
        $(".offer-option").each(function() {
          var variantId = parseInt($(this).data("variant-id"));
          var variantInCart = false;
          
          // Look for this variant in the cart
          for (var i = 0; i < cart.items.length; i++) {
            if (parseInt(cart.items[i].variant_id) === variantId) {
              variantInCart = true;
              console.log('Found variant in cart:', variantId);
              break;
            }
          }
        });
        
        // If main product not in cart, remove all offer products (by product type)
        if (!mainProductInCart) {
          // Get all variant IDs of offer products on this page
          var offerVariantIds = [];
          $(".offer-option").each(function() {
            offerVariantIds.push(parseInt($(this).data("variant-id")));
          });
          
          var itemsToRemove = [];
          
          for (var i = 0; i < cart.items.length; i++) {
            var cartVariantId = parseInt(cart.items[i].variant_id);
            var productType = cart.items[i].product_type;
            
            // If this is a warranty or deep clean product (by product type)
            if (
              offerVariantIds.includes(cartVariantId) || 
              productType === "Extended Warranty" 
            ) {
              itemsToRemove.push({
                id: cart.items[i].key || cartVariantId,
                variantId: cartVariantId
              });
            }
          }
          
          // If there are items to remove
          if (itemsToRemove.length > 0) {
            // Create a chain of promises to remove items sequentially
            let removePromise = Promise.resolve();
            
            itemsToRemove.forEach(item => {
              removePromise = removePromise.then(() => {
                return new Promise((resolve) => {
                  $.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: {
                      id: item.id,
                      quantity: 0
                    },
                    dataType: "json",
                    success: function(data) {
                      console.log('Related item removed from cart:', item.variantId);
                      resolve();
                    },
                    error: function() {
                      console.error('Failed to remove item:', item.variantId);
                      resolve(); // Resolve anyway to continue the chain
                    }
                  });
                });
              });
            });
            
            // After all items are removed, refresh the mini cart
            removePromise.then(() => {
              setTimeout(refreshMiniCart, 500);
            });
          }
          
          // Also uncheck all offer checkboxes on this page
          $(".offer-option").prop("checked", false);
        }
      },
      error: function(xhr, status, error) {
        console.error("Error fetching cart:", error);
      }
    });
  }
  
  // Function to validate cart items based on SKU matching
  function validateCart() {
    // Fetch and log the updated cart
    $.getJSON('/cart.js', function(cart) {
      console.log('Validating cart data:', cart);
      
      // Check if cart has items
      if (cart.item_count > 0) {
        console.log('Count Item', cart.item_count);
        
        // Arrays to store products info
        let normalProducts = [];
        let specialProducts = [];
        let productsToRemove = [];
        
        // First, categorize products as normal or special (warranty/deep clean)
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          
          // if (item.product_type === "Extended Warranty" || item.product_type === "Deep cleaning") {
            if (item.product_type === "Extended Warranty" ) {
            specialProducts.push({
              key: item.key,
              sku: item.sku,
              formattedSku: item.sku.replace(/\//g, '-'), // Convert all slashes to dashes
              product_type: item.product_type,
              title: item.title
            });
            console.log(`Found ${item.product_type} product: ${item.title}, SKU: ${item.sku}, Formatted SKU: ${item.sku.replace(/\//g, '-')}`);
          } else {
            normalProducts.push({
              sku: item.sku,
              formattedSku: item.sku.replace(/\//g, '-'), // Convert all slashes to dashes
              product_type: item.product_type,
              title: item.title
            });
            console.log(`Found normal product: ${item.title}, SKU: ${item.sku}, Formatted SKU: ${item.sku.replace(/\//g, '-')}`);
          }
        }
        
        // Check if we have any normal products at all
        if (normalProducts.length === 0 && specialProducts.length > 0) {
          // If there are only warranty/deep clean products, clear the entire cart
          console.log('Cart only contains warranty or deep clean items. Clearing cart...');
          $.post('/cart/clear.js', function(clearResponse) {
            console.log('Cart cleared:', clearResponse);
            // Reload the page if we're on the cart page
            if (window.location.pathname.includes('/cart')) {
              window.location.reload();
            } else {
              updateEmptyCartUI();
            }
          }, 'json');
          return;
        }
        
        // Check each special product against normal products
        for (let i = 0; i < specialProducts.length; i++) {
          const specialProduct = specialProducts[i];
          let matchFound = false;
          
          // Remove -EW or -DC from the formatted SKU
          let formattedSpecialSku = specialProduct.formattedSku
          .replace(/-EW$/, '')
          .replace(/-DC$/, '');
          
          // Compare against all normal products
          for (let j = 0; j < normalProducts.length; j++) {
            const normalProduct = normalProducts[j];
            
            console.log('specialProduct.cleanedFormattedSku ', formattedSpecialSku);
            console.log('normalProduct.formattedSku', normalProduct.formattedSku);
            
            if (formattedSpecialSku === normalProduct.formattedSku) {
            matchFound = true;
            console.log(`Exact SKU match found: ${formattedSpecialSku} matches ${normalProduct.formattedSku}`);
            break;
            }
          }
          
          // If no match was found, mark this product for removal
          if (!matchFound) {
            console.log(`No matching product found for ${specialProduct.product_type}: ${specialProduct.title}. Marking for removal.`);
            productsToRemove.push({
            id: specialProduct.key,
            quantity: 0
            });
          }
        }
        // If we have products to remove, update the cart
        if (productsToRemove.length > 0) {
          console.log('Removing unmatched warranty or deep clean items:', productsToRemove);
          
          // Build updates object for cart API
          let updates = {};
          for (let i = 0; i < productsToRemove.length; i++) {
            updates[productsToRemove[i].id] = 0;
          }
          
          // Use Shopify's cart update API to remove the items
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: updates },
            dataType: 'json',
            success: function(updatedCart) {
              console.log('Cart updated:', updatedCart);
              
              // If the cart is now empty after removing items, show empty cart
              if (updatedCart.item_count === 0) {
                // If we're on the cart page, reload the page
                if (window.location.pathname.includes('/cart')) {
                  window.location.reload();
                } else {
                  updateEmptyCartUI();
                }
              } else {
                // Reload page if we're on cart page
                if (window.location.pathname.includes('/cart')) {
                  window.location.reload();
                } else {
                  // Use the provided manuallyUpdateCart function to update the cart UI
                  manuallyUpdateCart(updatedCart);
                }
              }
            },
            error: function(error) {
              console.error('Error updating cart:', error);
            }
          });
        }
      }
    });
  }
  
  // Helper function to update UI when cart is empty
  function updateEmptyCartUI() {
    const emptyCartMainHTML = `
      <div data-t4s-scroll-me="" class="t4s-drawer__scroll t4s-current-scrollbar">
        <div class="t4s-cookie-message t4s-dn">Enable cookies to use the shopping cart</div>
        <div data-cart-items="" class="t4s-mini_cart__items t4s_ratioadapt t4s-product">
          <style>
            #t4s-mini_cart .t4s-drawer__bottom {
              opacity: 0;
              -webkit-transform: translateY(45px);
              transform: translateY(45px);
              -webkit-transition: opacity .25s cubic-bezier(.25,.46,.45,.94),-webkit-transform .25s cubic-bezier(.25,.46,.45,.94);
              transition: opacity .25s cubic-bezier(.25,.46,.45,.94),transform .25s cubic-bezier(.25,.46,.45,.94),-webkit-transform .25s cubic-bezier(.25,.46,.45,.94);
            }
          </style> 
          <div class="t4s-mini_cart__emty">
            <svg id="icon-cart-emty" widht="50" height="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M263.4 103.4C269.7 97.18 279.8 97.18 286.1 103.4L320 137.4L353.9 103.4C360.2 97.18 370.3 97.18 376.6 103.4C382.8 109.7 382.8 119.8 376.6 126.1L342.6 160L376.6 193.9C382.8 200.2 382.8 210.3 376.6 216.6C370.3 222.8 360.2 222.8 353.9 216.6L320 182.6L286.1 216.6C279.8 222.8 269.7 222.8 263.4 216.6C257.2 210.3 257.2 200.2 263.4 193.9L297.4 160L263.4 126.1C257.2 119.8 257.2 109.7 263.4 103.4zM80 0C87.47 0 93.95 5.17 95.6 12.45L100 32H541.8C562.1 32 578.3 52.25 572.6 72.66L518.6 264.7C514.7 278.5 502.1 288 487.8 288H158.2L172.8 352H496C504.8 352 512 359.2 512 368C512 376.8 504.8 384 496 384H160C152.5 384 146.1 378.8 144.4 371.5L67.23 32H16C7.164 32 0 24.84 0 16C0 7.164 7.164 0 16 0H80zM107.3 64L150.1 256H487.8L541.8 64H107.3zM128 456C128 425.1 153.1 400 184 400C214.9 400 240 425.1 240 456C240 486.9 214.9 512 184 512C153.1 512 128 486.9 128 456zM184 480C197.3 480 208 469.3 208 456C208 442.7 197.3 432 184 432C170.7 432 160 442.7 160 456C160 469.3 170.7 480 184 480zM512 456C512 486.9 486.9 512 456 512C425.1 512 400 486.9 400 456C400 425.1 425.1 400 456 400C486.9 400 512 425.1 512 456zM456 432C442.7 432 432 442.7 432 456C432 469.3 442.7 480 456 480C469.3 480 480 469.3 480 456C480 442.7 469.3 432 456 432z"></path></svg>
            <p>Your cart is empty.</p>
          </div>
        </div>
        <div data-cart-tools="" class="t4s-when-cart-emty t4s-mini_cart__tool t4s-mini_cart__tool_icon t4s-text-center"></div>
      </div>
    `;
    
    // Replace only the drawer__main content
    $('.t4s-drawer__main').html(emptyCartMainHTML);
    
    // Update cart counter to 0
    $('#t4s-mini_cart').attr('data-ccount', '0');
    
    // Reset the cart total price
    $('.t4s-cart__totalPrice').text('₹ 0');
  }
  
  // Hook into the Add to Cart button click event
  $(document).on('click', '.t4s-product-form__buttons button', function(e) {
    // Find the standard Shopify form
    var $form = $(this).closest('form');
    var productsToAdd = [];
    var messageDiv = $("#offer-message");
    
    // Check both checkboxes
    var hasExtendedWarranty = $("#extended-warranty").length > 0 && $("#extended-warranty").is(":checked");
    var hasDeepClean = $("#deep-clean").length > 0 && $("#deep-clean").is(":checked");
    
    // If either checkbox is checked, handle cart addition
    if (hasExtendedWarranty || hasDeepClean) {
      e.preventDefault(); // Prevent the default form submission
      messageDiv.text("Adding products...").fadeIn();
      
      // Add main product
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $form.serialize(),
        dataType: 'json',
        success: function(mainProductData) {
          console.log('Main product added:', mainProductData);
          
          // Create array to track additional products
          var additionalProducts = [];
          var productsAdded = 0;
          var totalProductsToAdd = 0;
          
          // Add extended warranty if checked
          if (hasExtendedWarranty) {
            var warrantyVariantId = $("#extended-warranty").data("variant-id");
            var warrantyTitle = $("#extended-warranty").data("title") || "Extended Warranty";
            additionalProducts.push({
              id: warrantyVariantId,
              title: warrantyTitle
            });
            totalProductsToAdd++;
          }
          
          // Add deep clean if checked
          if (hasDeepClean) {
            var deepCleanVariantId = $("#deep-clean").data("variant-id");
            var deepCleanTitle = $("#deep-clean").data("title") || "Deep Cleaning Service";
            additionalProducts.push({
              id: deepCleanVariantId,
              title: deepCleanTitle
            });
            totalProductsToAdd++;
          }
          
          // Add each additional product
          if (additionalProducts.length === 0) {
            // If no additional products, just update cart and finish
            finishAddToCart(messageDiv);
          } else {
            // Add each additional product with a delay
            function addProductsWithDelay() {
              var index = 0;
              
              function addNextProduct() {
                if (index >= additionalProducts.length) {
                  return; // All products added
                }
                
                var product = additionalProducts[index];
                
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    id: product.id,
                    quantity: 1
                  },
                  dataType: 'json',
                  success: function(data) {
                    console.log(product.title + ' added:', data);
                    productsAdded++;
                    
                    // If all products added, update cart and finish
                    if (productsAdded === totalProductsToAdd) {
                      finishAddToCart(messageDiv);
                    }
                  },
                  error: function(xhr) {
                    console.error('Error adding ' + product.title + ':', xhr);
                    productsAdded++;
                    
                    // Continue even if some products fail
                    if (productsAdded === totalProductsToAdd) {
                      finishAddToCart(messageDiv);
                    }
                  },
                  complete: function() {
                    index++;
                    // Wait 300ms before adding the next product
                    setTimeout(addNextProduct, 300);
                  }
                });
              }
              
              // Start adding the first product
              if (additionalProducts.length > 0) {
                addNextProduct();
              } else {
                finishAddToCart(messageDiv);
              }
            }
            
            // Start the sequential addition with delay
            addProductsWithDelay();
          }
        },
        error: function(xhr) {
          console.error('Error adding main product:', xhr);
          messageDiv.text("Error adding main product.").fadeIn();
          setTimeout(function() { messageDiv.fadeOut(); }, 3000);
          
          // Restore form functionality if main product fails
          $form.submit();
        }
      });
    }
    // If no offers checked, let the default form submission happen
  });
  
  // Function to finish the add to cart process
  function finishAddToCart(messageDiv) {
    messageDiv.text("Products added to cart!").fadeIn();
    
    window.offerMessageTimeout = setTimeout(function () {
      messageDiv.fadeOut();
    }, 3000);
    
    // Refresh mini cart
    setTimeout(function() {
      refreshMiniCart();
      
      // Open cart drawer
      setTimeout(function() {
        try {
          // Try to open cart drawer using theme's function
          if (typeof t4s !== 'undefined' && t4s.Cart) {
            if (typeof t4s.Cart.showDrawer === 'function') {
              t4s.Cart.showDrawer();
            } else if (typeof t4s.Cart.openDrawer === 'function') {
              t4s.Cart.openDrawer();
            }
          } else {
            // Try clicking the cart toggle button
            $('[data-drawer-toggle="cart"]').click();
          }
        } catch (e) {
          console.error("Error opening cart drawer:", e);
        }
      }, 300);
    }, 500);
  }
  
  // Handle checkbox changes - simplified to just log the change
  $(".offer-option").change(function () {
    var variantId = $(this).data("variant-id");
    var title = $(this).data("title");
    console.log('Checkbox changed:', {
      id: $(this).attr('id'),
      checked: $(this).is(":checked"),
      variantId: variantId,
      title: title
    });
  });
  
  // Listen for cart updates
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log('Cart updated, checking cart contents');
    validateCart();
  });
  
  // Add click event listener to mini cart remove buttons AND quantity selectors
  $(document).on('click', '.t4s-mini_cart__remove, .t4s-quantity-selector, .t4s-page_cart__remove', function(event) {
    // Wait 200ms before fetching cart data
    setTimeout(validateCart, 500);
  });
  
  // Check cart validation on page load
  console.log('Validating cart on page load...');
  validateCart();
});